import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "../pages/HomePage/Home";
import Register from "../pages/RegisterPage/Register";
import AvatarLogin from "../pages/AvatarLoginPage/AvatarLogin";
import SelectLanguage from "../pages/SelectLanguagePage/SelectLanguage";
import Information from "../pages/InformationPage/Information";
import Survey from "../pages/SurveyPage/Survey";
import Thankyou from "../pages/ThankyouPage/Thankyou";
import Error404 from "../pages/ErrorPage/Error404";
import Protected from "./Protected";

const Navigation = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Home />} />
        {/* <Route path='/' Component={Error404}  /> */}
        <Route path='register' element={<Register />} />
        <Route path='avatarlogin' element={<AvatarLogin />} />
        <Route
          path='selectlanguage'
          element={<Protected Component={SelectLanguage} />}
        />
        <Route
          path='informationPage'
          element={<Protected Component={Information} />}
        />
        <Route path='survey' element={<Protected Component={Survey} />} />
        <Route path='thankyou' element={<Protected Component={Thankyou} />} />
        <Route path='*' Component={Error404} />
        {/* <Route path='stag-2025-26' element={<Home />} /> */}
      </Routes>
    </BrowserRouter>
  );
};

export default Navigation;
